import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CategoriesSider from "../../Components/SideBar/CategoriesSider";
import useNavigateWithSearch from "../../Context/KBContext/hooks/useNavigateWithSearch";
import { useAllCategories } from "../../hooks/apis/useAllCategories";

export default function CategoryList({ focus }) {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(true);

  const [screenWidth] = useState(window.innerWidth);

  const { data: categoryList } = useAllCategories();

  const detectSize = () => {
    if (window.innerWidth < 800) {
      setVisible(false);
    } else {
      setVisible(true);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", detectSize);

    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [screenWidth]);

  const navigate = useNavigateWithSearch();
  const handleCategoryClick = (category) => {
    navigate(`/${category.slug}`);
    focus();
  };

  if (visible) {
    return (
        <CategoriesSider
          categories={categoryList}
          pathname={pathname}
          handleCategoryClick={handleCategoryClick}
        />
    );
  } else {
    return "";
  }
}
